import { render } from "./PersonalNewsPage.vue?vue&type=template&id=6c074d04&scoped=true"
import script from "./PersonalNewsPage.vue?vue&type=script&lang=js"
export * from "./PersonalNewsPage.vue?vue&type=script&lang=js"

import "./PersonalNewsPage.vue?vue&type=style&index=0&id=6c074d04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c074d04"]])

export default __exports__